import React from "react";
import axios from 'axios';
import urlList from "../../reducers/propertiesReducer";
import getAxiosConfig from "../../utils/axiosConfig";

const DeleteSegmentation = ({segmentationId, type, onDelete}) => {
    const handleDelete = async () => {
        try {
            await axios.get(
                urlList().segmentationUrl +
                `/deleteUserSegmentGroup/${type}/${segmentationId}`,
                getAxiosConfig()
            );
            console.log('Segmentation delete successfully');
            onDelete();
        } catch (error) {
            console.error('Error deleting segmentation:', error);
        }
    };

    return (
        <button onClick={handleDelete}>Delete group</button>
    );
}

export default DeleteSegmentation;

